import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SVGFill } from '../../svg';
import { Icon } from '../../icon';
import { Deprecated } from '../Deprecated';
var TextBoldIcon = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Icon, _extends({
    ref: ref
  }, props), /*#__PURE__*/React.createElement(SVGFill, {
    d: "M23.8899 15.3899H17.6101V33.8201H25C28.47 33.8201 31 31.7101 31 28.8201C31.0171 27.8873 30.7223 26.9756 30.1626 26.2292C29.6029 25.4829 28.8101 24.9447 27.9099 24.7C27.7752 24.6614 27.655 24.5841 27.5642 24.4773C27.4735 24.3705 27.4162 24.2393 27.3999 24.1001C27.3844 23.9584 27.4114 23.8151 27.4773 23.6887C27.5432 23.5623 27.645 23.4583 27.77 23.3899C28.4297 23.0611 28.9778 22.5455 29.3459 21.907C29.7141 21.2685 29.886 20.5356 29.8401 19.8C29.7801 16.15 26.5699 15.3899 23.8899 15.3899ZM20.6699 18.6201C20.6686 18.526 20.6861 18.4325 20.7212 18.3452C20.7563 18.2579 20.8082 18.1786 20.8743 18.1116C20.9403 18.0446 21.0192 17.9914 21.106 17.9551C21.1928 17.9188 21.2858 17.8999 21.3799 17.8999H23.52C25.52 17.8999 26.6499 18.9 26.6499 20.48C26.6519 20.862 26.5735 21.2402 26.4197 21.5898C26.2658 21.9395 26.0401 22.2529 25.7571 22.5095C25.4741 22.7661 25.1401 22.9601 24.7771 23.0791C24.4141 23.1981 24.0299 23.2393 23.6499 23.2H21.3799C21.1916 23.2 21.0111 23.1251 20.8779 22.9919C20.7448 22.8588 20.6699 22.6783 20.6699 22.49V18.6201ZM27.74 28.3899C27.74 30.1699 26.4299 31.3101 24.3999 31.3101H21.3999C21.2116 31.3101 21.0311 31.2352 20.8979 31.1021C20.7648 30.9689 20.6899 30.7884 20.6899 30.6001V26.1699C20.6899 25.9816 20.7648 25.8011 20.8979 25.668C21.0311 25.5348 21.2116 25.46 21.3999 25.46H24.22C26.39 25.46 27.74 26.5799 27.74 28.3899Z"
  }));
});
TextBoldIcon.displayName = 'TextBoldIcon';
TextBoldIcon.defaultProps = {
  'aria-label': 'Text Bold'
};
/**
 * @deprecated Use BoldIcon instead.
 */

export default Deprecated(TextBoldIcon, 'Use BoldIcon instead.');


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/theme/dist/esm/icons/TextBoldIcon/index.js
// module id = 1954
// module chunks = 12